import React from "react";

const ImageSkeleton = ({ type = "image", className }) => {
  return (
    <i
      className={`skeleton-loader flex items-center justify-center w-full h-full aspect-video ${className} fa-solid ${
        type === "video"
          ? "fa-photo-film"
          : type === "map"
          ? "fa-map-location-dot"
          : "fa-image"
      } xl:text-6xl lg:text-4xl md:text-4xl sm:text-4xl text-slate-100`}
    />
  );
};

export default React.memo(ImageSkeleton);
